export default __webpack_public_path__ + "static/media/unnamed_(3).3df6167b.png";